import React, { FC } from 'react';

export enum DataTestId {
    AVATAR = 'avatar',
    CLICK_OUT = 'click-out',
    BUSINESS_LOGIN = 'business-login',
    USER_LOGIN = 'user-login',
    SEARCH = 'search',
    MUTE = 'mute',
    POST_CARD_KEBAB = 'post-card-kebab',
    POST_CARD_KEBAB_BUTTON = 'post-card-kebab-button',
    POST_COLLECTION_CARD_KEBAB = 'post-collection-card-kebab',
    COLLECTION_KEBAB = 'collection-kebab',
    COLLECTION_MENU = 'collection-menu',
    COLLECTION_STATUS_DRAWER_TITLE = 'collection-status-drawer-title',
    COLLECTION_STATUS_DRAWER_DESCRIPTION_MODERATION = 'collection-status-drawer-description-moderation',
    PROFILE_KEBAB = 'profile-kebab',
    SUBSCRIBE_TEXT = 'subscribe-text',
    UNSUBSCRIBE_TEXT = 'unsubscribe-text',
    SHARE = 'share',
    SHARE_BUTTON = 'share-button',
    PROFILE = 'profile',
    PROFILE_MENU = 'profile-menu',
    FEED_MANAGEMENT = 'feed-management',
    BOOKMARK = 'bookmark',
    COLLECTION_BOOKMARK = 'collection_bookmark',
    LIKE = 'like',
    FILLED = 'filled',
    EMPTY = 'empty',
    DISLIKE = 'dislike',
    SUBSCRIBE_ICON = 'subscribe-icon',
    ANIMATE_FOOTER_DESCRIPTION = 'animate_footer_description',
    SLIDER_LEFT = 'slider-left',
    SLIDER_RIGHT = 'slider-right',
    EDIT_TEXT = 'edit-text',
    DELETE_TEXT = 'delete-text',
    COLLECTION_NAME = 'collection-name',
    COLLECTION_CARD_FROM_PROFILE = 'collection-card-from-profile',
    DELETE_FROM_COLLECTION = 'delete-from-collection',
    ONLY_IN_COLLECTION = 'only-in-collection',
    EVERYWHERE = 'everywhere',
    SAVE_TO_COLLECTION_DRAWER = 'save-to-collection-drawer',
    ADD_NEW_COLLECTION = 'add-new-collection',
    SAVE_TO_NEW_COLLECTION_BUTTON = 'save-to-new-collection-button',
    COLLECTION_NAME_INPUT = 'collection-name-input',
    EDIT_COLLECTION_DRAWER = 'edit-collection-drawer',
    BUSINESS_PROFILES = 'business-profiles',
    SEARCH_INPUT = 'search-input',
    SUBSCRIBED = 'subscribed',
    UNSUBSCRIBED = 'unsubscribed',
    BUSINESS_SEARCH_ROW = 'business-search-row',
    SAVE_POST_BUTTON = 'save-post-button',
    ADD_POST_BUTTON = 'add-post-button',
    SET_POST_FORM_FIELD = 'set-post-form-field',
    ADD_LINK_TO_PRODUCT_BLOCK = 'add-link-to-product-block',
    MODERATION_STATUS_CLOCK = 'moderation-status-clock',
    POST_TEXT = 'post-text',
    POST_TEXT_FOOTERT = 'post-text-footer',
    POST_CARD_COMPACT = 'post-card-compact',
    POST_CARD_GRID = 'post-card-grid',
    POST_CARD_GRID_MEDIA_COVER = 'post-card-grid-media-cover',
    CROSS_BUTTON = 'cross-button',
    DISCOVERY_BUTTON = 'discovery-button',
    SUPPORT = 'support',
    USER_AGREEMENT = 'user-agreement',
    APPLY_BETA_TEST = 'apply-beta-test',
    SAVE_COLLECTION = 'save-collection',
    REMOVE_SAVED_COLLECTION = 'remove-saved-collection',
    SAVED = 'saved',
    CREATED = 'created',
    EMPTY_COLLECTION_TEXT = 'empty-collection-text',
    SECRET_COLLECTION_RADIO = 'secret-collection-radio',
    PUBLIC_COLLECTION_RADIO = 'public-collection-radio',
    EDIT_COLLECTION_SUBMIT_BUTTON = 'edit-collection-submit-button',
    CREATE_COLLECTION_DIALOG = 'create-collection-dialog',
    CONTENT_PROMOTION_CHOOISING_POSTS_DIALOG = 'content-promotion-chooising-posts-dialog',
    CONTENT_PROMOTION_CHOOISING_GOALS_DIALOG = 'content-promotion-chooising-goals-dialog',
    CONTENT_PROMOTION_DATE = 'content-promotion-date',
    CONTENT_PROMOTION_DATE_NOW = 'content-promotion-date-now',
    CONTENT_PROMOTION_DATE_INPUT = 'content-promotion-date-input',
    ABOUT_CONTENT_PROMOTION_ICON_TEST_ID = 'about-content-promotion-icon',
    ABOUT_CONTENT_PROMOTION_MODAL_TEST_ID = 'about-content-promotion-modal',
    DESCRIPTION_STATUS = 'description-status',
    FEED_MANAGEMENT_FILTERS_DRAWER = 'feed-management-filters-drawer',
    CPA_REWARD_CONTENT_TEXT = 'cpa-reward-content-text',
    CPA_REWARD_CONTENT_BUTTON = 'cpa-reward-content-button',
    POST_CONTEXT_MENU = 'post-context-menu',
    BUSINESS_STATISTIC_INFO_DIALOG = 'business-statistic-info-dialog',
    CHECKOUT_BADGE = 'checkout-badge',
    CHECKOUT_BADGE_TOOLTIP = 'checkout-badge-tooltip',
    PRODUCT_SNIPPET_CHECKOUT_BUTTON = 'product-snippet-checkout-button',
    FILE_LOADING_NOTIFICATION = 'file-loading-notification',
    BUSINESS_TYPE_ACCOUNT_DRAWER = 'business-type-account-drawer',
    STORYBOOK_CARD_ACTIONS = 'storybook-card-actions',
    INPUT_SUGGEST = 'input-suggest',
    INPUT_SUGGEST_ITEM = 'input-suggest-item',
}

interface DataTestIdWrapperProps {
    children: React.ReactNode;
    dataTestId: DataTestId;
}

export const DataTestIdWrapper: FC<DataTestIdWrapperProps> = ({ children, dataTestId }) => (
    // TODO: Сделать привязку к dev окрожению, когда появится беты
    <div data-test-id={dataTestId}>{children}</div>
);
